export const SelectAllOptionValue = '__all__'
export type SelectAllOptionValue = typeof SelectAllOptionValue
